import { EmailTemplatesScope } from '@/shared/domain/enums/email-templates-scope.enum'

import { IEmailTemplateRepository } from './email-template.repository.interface'
import { EmailTemplateByOrganizationResponse, EmailTemplateResponse } from './email-template.types'

export class EmailTemplateService {
  constructor(private organizationRepository: IEmailTemplateRepository) {}

  async getById(id: string): Promise<EmailTemplateResponse> {
    return this.organizationRepository.getById(id)
  }

  async getByOrganization(
    organizationId: string,
    scope: keyof typeof EmailTemplatesScope,
  ): Promise<EmailTemplateByOrganizationResponse[]> {
    return this.organizationRepository.getByOrganization(organizationId, scope)
  }
}
